export default function gtmHelper (data) {
	// console.dir('gtmHelper', data);
	if (typeof dataLayer !== 'undefined') {
		dataLayer.push({
			event: 'filter-engagement',
			engagement_type: data?.type,
			engagement_group: data?.group,
			engagement_target: data?.target,
			term: data?.term,
		});
	}
}